import { flex } from "@/styles/mixins";
import styled from "styled-components";

export const InboundContentWrap = styled.div`
  ${flex('column', 'flex-start', 'flex-start')};
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;

  & .loading-box{
    width: 100%;
    margin-top: 20%;
    ${flex('row', 'center', 'center')};
  }

  & .error-row{
    background-color: red;
  }
`